export function createFailAction(type){
  return function fail(error){
    return {
      type,
      error
    }
  }
}
